Object.defineProperty(exports, '__esModule', { value: true });

var unsafeBadgeValues = ['negative', 'positive', 'attention'];
var isUnsafeBadge = function (badge) {
    return unsafeBadgeValues.includes(badge);
};

exports.isUnsafeBadge = isUnsafeBadge;
